// extracted by mini-css-extract-plugin
export default {"sidebyside":"Home_sidebyside__eqR5w","home":"Home_home__K8gFF","page":"Home_page__XcAmQ"};